import React from "react";
import "./Hero.css";
import hero_image from "../Assets/Freecycle_logo.png";
import hand_icon from "../Assets/recycle.png";
import arrow_icon from "../Assets/arrow.png";

const Hero = () => {
  return (
    <div className="hero">
      <div className="hero-left">
        <h2>Connecting Students Preserving Resources</h2>
        <div>
          <div className="hero-hand-icon">
            <p>FREECYCLE</p>
            <img src={hand_icon} alt="" />
          </div>
          <p></p>
          <p></p>
        </div>
        <div className="hero-latest-btn">
          <div>Latest Collection</div>
          <img src={arrow_icon} alt="" />
        </div>
      </div>
      <div className="hero-right">
        <img src={hero_image} alt="hero" />
      </div>
    </div>
  );
};

export default Hero;
